<template>
  <div style="overflow: auto">
    <!-- <div>万达广场商户交流分享满意度调查</div> -->
    <template v-if="page === 'home'">
      <div class="share">
        <div class="top">
          <img class="bg-top" src="@/assets/img/share-suggest/bg_top.png" />
          <img
            class="bg-title"
            src="@/assets/img/share-suggest/font_title.png"
          />
          <img
            class="bg-txt"
            src="@/assets/img/share-suggest/pic_top_right.png"
          />
        </div>

        <div class="question">
          <div class="card card1">
            <div class="flex flex-ac">
              <div class="title1">亲爱的商户朋友</div>
              <img class="quotes" src="@/assets/img/share-suggest/quotes.png" />
            </div>
            <p class="text">
              期盼本次交流分享能对您的日常经营有所助益、有所启发。为使今后的交流分享更加完美，令您的收获更多，请您对本次商户交流分享进行评估，以便于广场对今后的准备和组织工作进行改进和优化。感谢您的支持与合作！
            </p>
            <img
              class="pic-link link-left"
              src="@/assets/img/share-suggest/pic_link.png"
            />
            <img
              class="pic-link link-right"
              src="@/assets/img/share-suggest/pic_link.png"
            />
          </div>

          <div class="card">
            <div>
              <span class="text">品牌名称 </span>
              <span>{{ pageInfo.brandName }}</span>
            </div>
            <div>
              <span class="text">所在广场 </span>
              <span>{{ pageInfo.plazaName }}</span>
            </div>
          </div>

          <div
            class="card question1"
            v-for="(question, questionIndex) in questions"
            :key="questionIndex"
          >
            <div class="title">
              {{ question.title }} <span class="required">*</span>
            </div>
            <div class="flex answer" style="border-top: 1px solid #e7e7e7">
              <div
                class="item"
                v-for="choice in choices"
                :key="choice.value"
                @click="handleCheck(question.value, choice.value)"
              >
                <!-- E:\丙晟\工作\h5\h5-app-sh\src\assets\img\share-suggest/options1_1.png -->
                <!-- E:\丙晟\工作\h5\h5-app-sh\src\assets\img\share-suggest/options1_2.png -->
                <img
                  :src="
                    require(`@/assets/img/share-suggest/options${
                      choice.value
                    }_${question.checked == choice.value ? '2' : '1'}.png`)
                  "
                />
                <div>{{ choice.title }}</div>
              </div>
            </div>
          </div>

          <div class="card question1">
            <div class="title">5. 您对广场同业态商户交流分享的意见建议</div>
            <div class="textarea" style="position: relative">
              <van-field
                v-model="submitInfo.option5"
                rows="3"
                autosize
                type="textarea"
                maxlength="200"
                placeholder="请填写您对广场同业态商户交流分享的意见建议，非必填"
                show-word-limit
              />
            </div>
          </div>
        </div>

        <div class="foot">
          <div class="submit" @click="submit">提交</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="result">
        <template v-if="page === 'fail'"> 请在分享会当天填写！ </template>
        <template v-else> 您的答案已经提交! </template>
      </div>
    </template>
  </div>
</template>

<script>
import { questionnaireApi } from '@/api';
import moment from 'moment';
import { Field } from 'vant';
import 'vant/lib/field/style';
const questions = [
  { title: '1. 本次交流分享内容实用、收获较多 ', value: 1, checked: 0 },
  { title: '2. 本次交流分享准备充分、态度认真 ', value: 2, checked: 0 },
  { title: '3. 本次交流分享方式新颖、气氛活跃 ', value: 3, checked: 0 },
  { title: '4. 本次交流分享组织到位、安排合理 ', value: 4, checked: 0 },
];
const choices = [
  { title: '非常不满意', value: 1 },
  { title: '不满意', value: 2 },
  { title: '一般', value: 3 },
  { title: '满意', value: 4 },
  { title: '非常满意', value: 5 },
];
export default {
  components: { VanField: Field },
  data() {
    return {
      questions,
      choices,
      submitInfo: {
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        option5: '',
      },
      pageInfo: {},
      page: 'home',
    };
  },
  methods: {
    handleCheck(questionValue, choiceValue) {
      let question = this.questions.find((v) => v.value == questionValue);
      question.checked = choiceValue;
      let index = this.questions.findIndex((v) => v.value == questionValue);
      this.$set(this.questions, index, question);
    },
    submit() {
      const emojiReg =
        /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;

      let checked = this.questions.map((v) => v.checked);
      if (checked.includes(0)) return this.$toast.fail('有未选择项');
      if (emojiReg.test(this.submitInfo.option5))
        return this.$toast('提交内容不能包含表情符号');
      this.submitInfo.option1 = checked[0] * 5;
      this.submitInfo.option2 = checked[1] * 5;
      this.submitInfo.option3 = checked[2] * 5;
      this.submitInfo.option4 = checked[3] * 5;

      let data = {
        ...this.submitInfo,
        plazaId: this.pageInfo.plazaId,
        brandId: this.pageInfo.brandId,
        monthKey: moment(this.pageInfo.date).format('YYYYMMDD'),
      };
      questionnaireApi.scoreAdd(data).then(() => {
        this.page = 'success';
      });
    },
  },
  mounted() {
    let { info } = this.$route.query;

    let codeUrl = window.atob(info);
    let url = window.decodeURI(codeUrl);
    let pageInfo = JSON.parse(url);

    this.pageInfo = pageInfo;
    let date = pageInfo.date;

    if (
      new Date(date).toLocaleDateString() !== new Date().toLocaleDateString()
    ) {
      this.page = 'fail';
    }
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.flex-jc {
  justify-content: center;
}
.flex-ac {
  align-items: center;
}
.required {
  color: #FF6F00;
}

.share {
  background: #ffeedb;
  overflow: auto;
  border: 1px solid #ffeedb;
  overflow-x: hidden;
  margin-bottom: 40px;
  .top {
    position: relative;
    .bg-top {
      height: 240px;
    }
    .bg-title {
      height: 67px;
      position: absolute;
      top: 50px;
      left: 24px;
    }
    .bg-txt {
      height: 143px;
      position: absolute;
      top: 24px;
      right: 20px;
    }
  }
  .question {
    position: relative;
    margin-top: -90px;
    z-index: 9;
    padding: 0 12px;
    text-align: left;

    font-size: 14px;
    font-weight: 400;
    color: #111111;
    line-height: 22px;

    .card {
      margin-top: 12px;
      padding: 16px 12px;
      background: #fff;
      border-radius: 8px;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        padding-bottom: 16px;
      }
      .text {
        font-size: 14px;
        color: #666666;
        margin-right: 5px;
      }
      .answer {
        padding: 16px 0 0 0;
        font-size: 12px;
        color: #111111;
        .item {
          width: 20%;
          text-align: center;
        }
        img {
          width: 40px;
          height: 40px;
        }
      }
      .textarea {
        .van-cell {
          background: #f5f5f5;
        }
      }
    }
    .card1 {
      align-items: center;
      position: relative;
      .title1 {
        font-size: 16px;
        font-weight: 600;
        color: #111111;
      }
      .quotes {
        width: 16px;
        height: 16px;
        margin-left: 10px;
      }
      .pic-link {
        position: absolute;
        width: 10px;
        height: 36px;
        bottom: -24px;
      }
      .link-left {
        left: 20px;
      }
      .link-right {
        right: 20px;
      }
    }
  }
  .foot {
    padding: 12px;
    background: #fff;
    margin-top: 15px;
    .submit {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #FF6F00;
      border-radius: 22px;
      font-size: 18px;
      font-weight: 500;
      color: #ffeedb;
    }
  }
}

.result {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>